import { Koi } from '@ksyos/koi';
import { ServiceCode } from '@common/enums';

export type Medication = {
    dosageInstruction: string | null;
    dosageUnit: string | null;
    dosageValue: string | null;
    endDate: string | null;
    medInstrCode: string | null;
    medInstrName: string | null;
    medInstrSystem: string | null;
    mkcodeCode: string | null;
    mkcodeSystem: string | null;
    mkcodeSystemName: string | null;
    name: string | null;
    quantityCode: string | null;
    quantityCodeSystem: string | null;
    quantityDisplayName: string | null;
    quantityValue: string | null;
    startDate: string | null;
};

const medication = Koi.object({
    dosageInstruction: Koi.string().max(10000).allow('', null),
    dosageUnit: Koi.string().max(255).allow('', null),
    dosageValue: Koi.string().max(255).allow('', null),
    endDate: Koi.koi().endDate().allow('', null),
    medInstrCode: Koi.string().max(255).allow('', null),
    medInstrName: Koi.string().max(255).allow('', null),
    medInstrSystem: Koi.string().max(255).allow('', null),
    mkcodeCode: Koi.string().max(255).allow('', null),
    mkcodeSystem: Koi.string().max(255).allow('', null),
    mkcodeSystemName: Koi.string().max(255).allow('', null),
    name: Koi.string().max(255).allow('', null),
    quantityCode: Koi.string().max(255).allow('', null),
    quantityCodeSystem: Koi.string().max(255).allow('', null),
    quantityDisplayName: Koi.string().max(255).allow('', null),
    quantityValue: Koi.string().max(255).allow('', null),
    startDate: Koi.koi().date().allow('', null),
});

export type Medications = Medication[];

export const medications = Koi.array().items(medication);

export const medicationsSchema = {
    schema: medications,
};

export const servicesWithPatienUsesMedicationForRequest = [
    ServiceCode.TPC,
    ServiceCode.TFO,
    ServiceCode.TOO,
    ServiceCode.TCCr,
    ServiceCode.TCCi,
    ServiceCode.TCCh,
    ServiceCode.TPO,
    ServiceCode.GGZCg,
    ServiceCode.GGZCt,
    ServiceCode.GGZCtriage,
    ServiceCode.GGZCf2f,
    ServiceCode.GGZCmdo,
    ServiceCode.GGZv,
    ServiceCode.OSASV,
    ServiceCode.PILOT,
    ServiceCode.TCOR,
    ServiceCode.TFC,
    ServiceCode.TOV,
    ServiceCode.DermaC,
    ServiceCode.DermaCwond,
    ServiceCode.DermaCsc,
    ServiceCode.DermaSnelC,
    ServiceCode.DermaSnelCsc,
    ServiceCode.GTC,
    ServiceCode.OrthO,
    ServiceCode.OrthOFol,
];

export const servicesWithPatienUsesMedicationForProcedure = [ServiceCode.TPO, ServiceCode.PILOT];
